import { api } from "@/api"

import type { MaybeRef } from "@vueuse/core"
import { unref } from "vue"
import { useQuery } from "@tanstack/vue-query"

export type RetrieveZReportResponse = {
  createdAt: Date

  deviceId: number
  deviceSerialNumber: string

  headerFields: Record<string, string> | null
  fromReceiptNo: string | null
  toReceiptNo: string | null

  saleCount: number | null
  saleAmount: number | null
  refundCount: number | null
  refundAmount: number | null
  completionCount: number | null
  completionAmount: number | null
  gratuityCount: number | null
  gratuityAmount: number | null
  cashbackCount: number | null
  cashbackAmount: number | null

  voidCount: number | null
  voidAmount: number | null
  preAuthCount: number | null
  preAuthAmount: number | null
  preAuthTopUpCount: number | null
  preAuthTopUpAmount: number | null
  preAuthCancelledCount: number | null
  preAuthCancelledAmount: number | null

  totalCount: number | null
  totalAmount: number | null

  nativeReceiptLines: string[] | null
  payloadJson: Record<string, unknown> | null

  receipt: string | null
}

const retrieveZReport = async (
  zReportId: string
): Promise<RetrieveZReportResponse> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<RetrieveZReportResponse>
  >(`/z-reports/${zReportId}/`)

  return {
    ...body,
    createdAt: DateFns.parseISO(body.createdAt),
  }
}

export const useZReport = (zReportId: MaybeRef<string>) =>
  useQuery(
    [BASE_Z_REPORTS_QUERY_KEY, zReportId] as const,
    () => retrieveZReport(unref(zReportId)),
    {
      enabled: Boolean(unref(zReportId)),
      staleTime: 0,
    }
  )
